
import ClickOutside from "vue-click-outside";
import DefinitionContent from "./DefinitionContent.vue";
import { getWordDefinition } from "@/common/services/wordDefinitionService";

export default {
	name: "Definition",
	components: { DefinitionContent },
	directives: {
		ClickOutside,
	},
	inject: ["isCompactMode"],
	props: {
		word: {
			type: String,
			required: true,
		},
		coverSpace: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			definitionIsOpen: false,
			definitionIsLoading: false,
			definition: "",
			definitionType: "",
			definitionWindowRightPlacement: "",
			popupPlacementX: 0, // current horizontal offset
		};
	},
	computed: {
		buttonContent() {
			if (this.coverSpace) {
				return;
			}

			return this.isCompactMode ? "def" : "definition";
		},
	},
	methods: {
		placeOnXAxis() {
			const button = this.$refs.button;
			const popupWindow = this.$refs.popup;
			if (!button || !popupWindow) {
				return;
			}

			const rect = button.getBoundingClientRect();
			const offset = this.coverSpace ? 0 : 35;

			this.popupPlacementX = window.innerWidth - offset - rect.right;
		},
		onButtonClick() {
			if (!this.definitionIsOpen) {
				this.getDefinition();
			}
			this.definitionIsOpen = !this.definitionIsOpen;

			if (this.definitionIsOpen) {
				this.placeOnXAxis();
				window.addEventListener("resize", this.placeOnXAxis);

				this.$emit("opened");
			} else {
				window.removeEventListener("resize", this.placeOnXAxis);
				this.$emit("closed");
			}
		},
		onWindowCloseButtonClick() {
			this.definitionIsOpen = false;
			window.removeEventListener("resize", this.placeOnXAxis);

			this.$emit("closed");
		},
		onDefinitionWindowClickOutside(e) {
			if (e.composedPath().includes(this.$refs?.button)) {
				return false;
			}

			window.removeEventListener("resize", this.placeOnXAxis);
			this.definitionIsOpen = false;
			this.$emit("closed");
		},
		getDefinition() {
			this.definitionIsLoading = true;

			getWordDefinition(this.$axios, this.$config, this.word)
				.then(({ sense, partOfSentence }) => {
					this.definition = sense;
					this.definitionType = partOfSentence;
				})
				.catch(() => {
					this.$emit("onDefinitionNotFound");
					this.definition = "";
					this.definitionType = "";
				})
				.finally(() => {
					this.definitionIsLoading = false;
				});
		},
	},
};
